import { AlertController, AlertButtonRole } from 'providers/alert-controller';
import { LL } from 'i18n/i18n.service';
import { TranslatedString } from 'models/translated-string';

/**
 * Present the shared scan-failure "Try Again" + Cancel alert used by every AI
 * scanner on a transient provider/network failure. Returns 'retry' when the user
 * taps Try Again, and 'cancel' for the Cancel button or any dismissal (backdrop /
 * back button), so a dismissal never triggers an accidental re-run.
 *
 * The buttons reuse the existing common i18n strings — no new i18n. The caller
 * supplies the already-resolved title/message so each scanner keeps its own
 * error copy, and the caller owns its own view state (errorAlertOpen,
 * markForCheck, viewDestroyed) and the retry re-run.
 */
export async function showScanRetryAlertAsync(
  alertCtrl: AlertController,
  title: TranslatedString,
  message: TranslatedString,
): Promise<'retry' | 'cancel'> {
  const choice = await alertCtrl.showAlertAsync<'retry' | 'cancel'>({
    title,
    message,
    buttons: [
      { text: LL.common.buttons.tryAgain(), role: AlertButtonRole.Primary, result: 'retry' },
      { text: LL.common.buttons.cancel(), role: AlertButtonRole.Cancel, result: 'cancel' },
    ],
  });
  return choice === 'retry' ? 'retry' : 'cancel';
}
